/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorActualDetailConfig } from '../../config/error.config';
export interface IErrorActualDetailPluginMethods extends IPluginMethodMap {
  getErrorActualDetailSync(args?: any): any;
}

export class ErrorActualDetailPlugin implements IAgentPlugin {
  readonly methods: IErrorActualDetailPluginMethods;

  constructor() {
    this.methods = {
      getErrorActualDetailSync: this.getErrorActualDetailSync.bind(this),
    };
  }

  getErrorActualDetailSync(args?: any) {
    return {
      error: errorActualDetailConfig,
    };
  }
}
